export default __webpack_public_path__ + "static/media/IndependenceNew2.aed28894.JPG";